exports.Types = {
    '1': {
        id: '1',
        name: "Facebook",
        fa: "fa-facebook",
        color: "#3b5998",
        split: "facebook.com/"
    },
    //'2': {
    //  id: '2',
    //  name: "Google+",
    //  fa: "fa-google-plus",
    //  color: "#dd4b39",
    //  split: "plus.google.com/+"
    //},
    '3': {
        id: '3',
        name: "Instagram",
        fa: "fa-instagram",
        color: "#125688",
        split: "instagram.com/"
    },
    '4': {
        id: '4',
        name: "Twitter",
        fa: "fa-twitter",
        color: "#55acee",
        split: "twitter.com/"
    },
    '5': {
        id: '5',
        name: "Other",
        fa: "fa-globe",
        color: "#8C8C8B"
    },
    '6': {
        id: '6',
        name: "LinkedIn",
        fa: "fa-linkedin",
        color: "#0077B5"
    },
    '7': {
        id: '7',
        name: "WhatsApp",
        fa: "fa-whatsapp",
        color: "#5CBE4A",
        mobileOnly: true
    }
};

exports.FACEBOOK =  exports.Types['1'];
exports.GOOGLE =  exports.Types['2'];
exports.INSTAGRAM =  exports.Types['3'];
exports.TWITTER =  exports.Types['4'];
exports.OTHER =  exports.Types['5'];
exports.LINKEDIN = exports.Types['6'];
exports.WHATSAPP = exports.Types['7'];

exports.getUsername = function(item){
  var t = exports.Types[item.socialMediaType + ""];
  if (!t.split  || !item.socialMediaUrl) return null;
  var splits = item.socialMediaUrl.split(t.split);
  if (splits.length <= 1) return null;
  return splits[splits.length - 1];
}

exports.filterBy = function(arr, key){
  return arr.filter(function(item){
    return item.socialMediaType == key.id && item.socialMediaUrl;
  })
}
